import { useEffect, useState, useCallback } from "react";
import { Instagram } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../ui/carousel";
import { INSTAGRAM_REELS, CONTACT } from "../../data/site";
import { track, EVENTS } from "../../lib/analytics";

const processEmbeds = () => {
  if (window.instgrm && window.instgrm.Embeds) {
    window.instgrm.Embeds.process();
  }
};

export const InstagramSlideshow = () => {
  const [api, setApi] = useState(null);

  const loadEmbedScript = useCallback(() => {
    const id = "instagram-embed-script";
    if (document.getElementById(id)) {
      processEmbeds();
      return;
    }
    const s = document.createElement("script");
    s.id = id;
    s.async = true;
    s.src = "https://www.instagram.com/embed.js";
    s.onload = processEmbeds;
    document.body.appendChild(s);
  }, []);

  useEffect(() => {
    loadEmbedScript();
    // Re-process shortly after mount in case the script was already cached.
    const t = setTimeout(processEmbeds, 800);
    return () => clearTimeout(t);
  }, [loadEmbedScript]);

  // Re-process when the carousel finishes settling (Embla reflow).
  useEffect(() => {
    if (!api) return;
    api.on("reInit", processEmbeds);
    return () => api.off("reInit", processEmbeds);
  }, [api]);

  return (
    <div data-testid="instagram-slideshow" className="relative">
      <Carousel
        setApi={setApi}
        opts={{ align: "start", loop: false }}
        className="mx-auto w-full"
      >
        <CarouselContent>
          {INSTAGRAM_REELS.map((url, i) => (
            <CarouselItem
              key={url}
              data-testid={`ig-slide-${i}`}
              className="basis-full sm:basis-1/2 lg:basis-1/3"
            >
              <div className="mx-auto min-h-[500px] max-w-[400px]">
                <blockquote
                  className="instagram-media"
                  data-instgrm-permalink={url}
                  data-instgrm-version="14"
                  style={{
                    background: "#FFF",
                    border: 0,
                    borderRadius: "12px",
                    boxShadow: "0 8px 30px rgba(22,50,79,0.06)",
                    margin: 0,
                    padding: 0,
                    width: "100%",
                  }}
                >
                  <a href={url} target="_blank" rel="noopener noreferrer">
                    View this reel on Instagram
                  </a>
                </blockquote>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious
          data-testid="ig-slide-prev"
          className="left-2 border-none bg-white/90 text-navy shadow-cozy hover:bg-white"
        />
        <CarouselNext
          data-testid="ig-slide-next"
          className="right-2 border-none bg-white/90 text-navy shadow-cozy hover:bg-white"
        />
      </Carousel>

      <div className="mt-8 text-center">
        <a
          href={CONTACT.instagram}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="ig-slideshow-follow"
          onClick={() => track(EVENTS.INSTAGRAM_CLICK, { location: "slideshow-follow" })}
          className="btn-teal"
        >
          <Instagram className="h-5 w-5" /> Follow @harborhome_co
        </a>
      </div>
    </div>
  );
};

export default InstagramSlideshow;
